import { Box, Typography } from "@mui/material";

type NotFoundProps = {
    text: string,
}

export const NotFound = ({ text }: NotFoundProps) => (
  <Box sx={{
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}>
    <Typography variant="h6">{text}</Typography>
  </Box>
)
